import { useMutation } from '@tanstack/react-query'

import { editArtifacts } from '../../api/artifacts'

export const useUpdateArtifacts = () => useMutation({ mutationFn: editArtifacts })
